import { createActionGroup, emptyProps } from '@ngrx/store';

/**
 * UI Actions
 * 
 * Defines all actions for UI state management.
 * These actions handle cross-cutting UI concerns.
 */
export const UiActions = createActionGroup({
  source: 'UI',
  events: {
    // ========== Sidenav Actions ==========
    'Toggle Sidenav': emptyProps(),
    'Open Sidenav': emptyProps(),
    'Close Sidenav': emptyProps(),
    
    // Future UI actions can be added here:
    // 'Show Safari Guide': emptyProps(),
    // 'Network Online': emptyProps(),
  }
});
